/**
 * The New Western public application — the ONLY thing served on the NW
 * domain (apply.quickdrawfunding.com). No portal, no Left Main intake:
 * the two brands' routes never coexist on one host.
 */
import { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import type { FormSubmissionResponse } from '@qdf/shared';
import { SandboxBanner } from '../layout/SandboxBanner.js';
import { NwHeader } from './NwHeader.js';
import { NwFooter } from './NwFooter.js';
import { NwIntakePage } from './NwIntakePage.js';
import { NwConfirmationPage } from './NwConfirmationPage.js';

function NwIntakeApp() {
  const [submission, setSubmission] = useState<FormSubmissionResponse | null>(null);

  return (
    <div className="min-h-screen flex flex-col">
      <SandboxBanner />
      <NwHeader />
      <main className="flex-1">
        {submission ? (
          <NwConfirmationPage
            submission={submission}
            onStartNew={() => setSubmission(null)}
          />
        ) : (
          <NwIntakePage onSuccess={setSubmission} />
        )}
      </main>
      <NwFooter />
    </div>
  );
}

export function NwApp() {
  useEffect(() => {
    document.title = 'New Western — Apply for Funding';
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NwIntakeApp />} />
        <Route path="/apply" element={<NwIntakeApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
